import React from "react";
import { InputText } from "primereact/inputtext";
import styled from "styled-components";

export interface InputProps {
  disabled: boolean;
  value: any;
  label: string;
  placeholder: string;
  onChange?: (event: any) => void;
}

const CustomInput = styled(InputText)`
  background: #f2f2f2;
  border-radius: 5px;
  border: solid 1px #d5d5d5;
  color: #484848;
  height: 2rem;
  margin: 0rem 1rem 1rem 0rem;
  width: 18rem;
  font-weight: 600;
  padding: 1rem;
  :enabled:hover {
    border-color: #d5d5d5 !important;
  }
`;

const CustomLabel = styled.div`
  font-style: italic;
  color: #484848;
  font-weight: 100;
  margin-bottom: 0.5rem;
`;

const Input: React.FC<InputProps> = ({
  label,
  disabled,
  value,
  placeholder,
  onChange,
}) => (
  <div>
    <CustomLabel>{label}</CustomLabel>
    <CustomInput
      placeholder={placeholder}
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e)}
    />
  </div>
);

export default Input;
